export enum DatabaseQueries {
  GET_STYLES = `
    query Styles(
        $where: StyleFilterInput,
        $first: Int,
        $after: String 
    ) {
        styles(
            where: $where,
            first: $first,
            after: $after 
        ) {
            nodes {
                brand {
                    id
                    name
                }
                category {
                    id
                    name
                }
                currentStyleStatus {
                    styleStatus {
                        id
                        name
                    }
                }
                styleGroup {
                    id
                    name
                }
                styleDescription {
                    id
                    name
                }
                gender {
                    id
                    name
                }
                schema{
                    collection{
                        id
                        name
                    }
                }
            
                 
                modelId
                code
                name
                orderStyles {
                    order {
                        id
                        creationDate
                        orderStatus {
                            id
                            name
                            # tag
                        }
                    }
                }
                warehouseArticles {
                    id
                    availableQty
                    operationType
                    warehouse{
                        id
                        code
                        description
                    }
                    color{
                        id
                        code
                        autoGeneratedColorName
                    }
                    size {
                        id
                        name
                    }
                }
            }

            totalCount
        }
    }
    `,

  GET_STYLES_NO_STOCK = `
    query StylesNoStock(
        $where: StyleFilterInput,
        $first: Int,
        $after: String 
    ) {
        stylesNoStock(
            where: $where,
            first: $first,
            after: $after 
        ) {
            nodes {
                brand {
                    id
                    name
                }
                category {
                    id
                    name
                }
                currentStyleStatus {
                    styleStatus {
                        id
                        name
                    }
                }
                styleGroup {
                    id
                    name
                }
                styleDescription {
                    id
                    name
                }
                gender {
                    id
                    name
                }
                schema {
                    collection {
                        id
                        name
                    }
                    schemaSizes {
                        sizeId
                        sizeCode
                    }
                    schemaTeamColors {
                        colorId
                        colorCode
                    }
                }
                 
                modelId
                code
                name
                orderStyles {
                    order {
                        id
                        creationDate
                        orderStatus {
                            id
                            name
                            # tag
                        }
                    }
                }
            }

            totalCount
        }
    }
    `,

  GET_STYLES_PRICES = `
    query StylesCost(
        $where: StyleCostFilterInput,
        $startDate: LocalDate!,
        $endDate: LocalDate!,
        $first: Int,
        $after: String
    ) {
        stylesCost(
            startDate: $startDate,
            endDate: $endDate,
            where: $where,
            first: $first,
            after: $after
        ) {
            totalCount
            nodes {
                brand {
                    id
                    name
                }
                category {
                    id
                    name
                }
                
                styleGroup {
                    id
                    name
                }
                styleDescription {
                    id
                    name
                }
                gender {
                    id
                    name
                }
                 
                modelId
                code
                name
                periodAverage
                priceChanges {
                    orderId
                    orderCreationDate
                    price
                }
            }
        }
    }
    `,

  GET_SELECTED_STYLES = `
    query OrderSelectedSizes($orderId: Int!) {
        orderSelectedSizes(orderId: $orderId) {
            modelId
            colors {
                id
                label
                sizes {
                    id
                    label
                }
            }
        }
    }
     `,

  GET_STYLE_DETAILS = `
    query StyleDetails($modelId: Int!, $first: Int, $after: String) {
        styleDetails(
            modelId: $modelId,
            first: $first,
            after: $after 
        ) {
            nodes {
                colorId
                colorName
                defaultColor
                colorsSizeGroups {
                    sizeGroupId
                    sizeGroupName
                    shots {
                        shotId
                        estimatedFileName
                        imgPath
                        mandatory
                        isAi
                        hasHistory
                        shotApprovalStatusId
                        shotType {
                            id
                            label
                        }
                        aspectRatio {
                            id
                            label
                        }
                        mediaFormat {
                            id
                            label
                        }
                         
                    }
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
            totalCount
        }
    }
    `,
  GET_WAREHOUSES = `
    query Warehouses($where: WarehouseFilterInput, $first: Int, $after: String) {
        warehouses(first: $first, after: $after,  where: $where, order: { code: ASC, description: ASC }
        ) {
            nodes {
                code
                description
                id
            }
            totalCount
        }
    }
    `,
  DELETE_IMAGES_BY_MODEL_ID = `
        mutation DeleteImageByModelId($ModelId: Int!) {
            deleteImageByModelId(deleteImageByModelIdInput: { modelId: $ModelId, cancelApproved: true }) {
                success
            }
        }
    `,
  GET_STYLE_FILENAMES = `
    query StyleFilenames($modelId: Int!) {
        styleFilenames(modelId: $modelId)
    }
    `,
  GET_WAREHOUSE_ARTICLE_RESUMEE_TABLE = `
    query WarehouseArticleResumeeTable($modelId: Int!) {
        warehouseArticleResumeeTable(modelId: $modelId) {
            warehouse {
                id
                label
            }
            color {
                id
                label
            }
            sizes {
                id
                label
            }
        }
    }
    `,
  GET_IMAGE_HISTORY = `
    query ImageHistory($imageId: Int!) {
        imageHistory(imageId: $imageId) {
            nodes {
                selected
                shotId
                imgPath
                mandatory
                shotApprovalStatusId
                estimatedFileName
                isAi
                hasHistory
                source {
                    orderId
                    date
                }
                shotType {
                    id
                    label
                }
                aspectRatio {
                    id
                    label
                }
                mediaFormat {
                    id
                    label
                }
            }
        }
    }
    `
}
